HuesMdl.service( 'WishlistSrv', [function () {
	//var hueWishlist = new Wishlist( 'hues-wishlist', $('[data-wishlist=hues]') );
	var hueWishlist = false;
	return {


		getHueWislist : function() {
			if( hueWishlist )
				return hueWishlist;


			hueWishlist = new Wishlist( 'hues-wishlist', $('[data-wishlist=hues]') );
			//hueWishlist.init();
			return hueWishlist;


		}
	}
}]);
